import { useCallback, useState } from "react";

// Per-device best scores for Paper Log Practice scenarios.
// Stored in localStorage so a driver can come back and beat their score.
const KEY = "routehaul_paperlog_scores_v1";

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
};

export function usePaperLogScores() {
  const [scores, setScores] = useState(read);

  // Returns true if this attempt set a new best for the scenario.
  const saveAttempt = useCallback((key, score, compliant) => {
    let isBest = false;
    setScores((prev) => {
      const existing = prev[key];
      isBest = !existing || score > existing.best;
      const best = isBest ? score : existing.best;
      const bestCompliant = isBest ? compliant : existing.compliant;
      const next = { ...prev, [key]: { best, compliant: bestCompliant, savedAt: new Date().toISOString() } };
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch {}
      return next;
    });
    return isBest;
  }, []);

  return { scores, saveAttempt };
}
